import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { ThemeToggle } from "@/components/ThemeToggle";

const NAV = [
  { to: "/", label: "Dashboard", shortcut: "g d" },
  { to: "/projects", label: "Projects", shortcut: "g j" },
  { to: "/costs", label: "Costs", shortcut: "g c" },
  { to: "/keys", label: "Keys", shortcut: "g k" },
  { to: "/real-keys", label: "Real keys", shortcut: "g r" },
  { to: "/proxy-keys", label: "Proxy keys", shortcut: "g p" },
  { to: "/import", label: "Import", shortcut: "g i" },
  { to: "/audit", label: "Audit", shortcut: "g a" },
  { to: "/approvals", label: "Approvals", shortcut: "g v" },
  { to: "/users", label: "Users", shortcut: "g u" },
  { to: "/settings", label: "Settings", shortcut: "g s" },
];

export function Shell() {
  const { me, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen grid grid-cols-[240px_1fr]">
      <aside className="border-r border-white/5 bg-ink-900/80 px-4 py-6">
        <Link to="/" className="flex items-center gap-2 px-2 mb-8">
          <div className="w-8 h-8 rounded-lg bg-accent-500 grid place-items-center text-ink-900 font-bold">
            G
          </div>
          <div>
            <div className="text-sm font-semibold tracking-wide">Gatekeeper</div>
            <div className="text-[11px] text-slate-500">api key vault</div>
          </div>
        </Link>
        <nav className="flex flex-col gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) =>
                `group flex items-center justify-between px-3 py-2 rounded-lg text-sm transition-colors ${
                  isActive
                    ? "bg-accent-500/15 text-accent-500"
                    : "text-slate-400 hover:text-slate-100 hover:bg-white/5"
                }`
              }
            >
              <span>{n.label}</span>
              <kbd className="text-[10px] text-slate-600 mono opacity-0 group-hover:opacity-100 transition-opacity">
                {n.shortcut}
              </kbd>
            </NavLink>
          ))}
        </nav>

        <div className="mt-6 mx-2 px-3 py-2 rounded-lg border border-white/5 bg-white/[0.02] text-[11px] text-slate-500 flex items-center justify-between">
          <span>Quick open</span>
          <kbd className="mono px-1.5 py-0.5 rounded bg-white/5 border border-white/10 text-slate-300">
            ⌘K
          </kbd>
        </div>

        <div className="mt-auto pt-6 text-xs text-slate-500 px-2 space-y-2">
          <ThemeToggle />
          <div>
            Signed in as <span className="text-slate-200">{me?.username}</span>
          </div>
          <button
            onClick={async () => {
              await logout();
              nav("/login");
            }}
            className="text-rose-400 hover:text-rose-300"
          >
            Sign out
          </button>
          <div className="pt-1 text-slate-600">
            Press <kbd className="mono px-1 rounded bg-white/5 border border-white/10">?</kbd> for
            shortcuts
          </div>
        </div>
      </aside>
      <main className="p-8 max-w-screen-2xl">
        <Outlet />
      </main>
    </div>
  );
}
